
import { tableColumnsListAgents } from "./AgentsTable";
import AgentsTableOperationTableVue from "./AgentsTableOperationTable.vue";
import NoResultsFound from "@/components/NotFound/NoResultsFound.vue";

import {
  agentApplicationsMapActions,
  agentApplicationsMapGetters
} from "@/store/modules/agentApplications";
import VueWithMixins from "@/helpers/mixins";
import AgentApplicationMixin from "./AgentApplicationMixin";

export default VueWithMixins(AgentApplicationMixin).extend({
  name: "agents",
  components: {
    NoResultsFound
  },
  data() {
    return {
      tableColumns: tableColumnsListAgents,
      successMessage: "",
      filters: [
        {
          field: "status",
          title: "Status",
          options: [
            { label: "Spam", value: "spam" },
            { value: "rejected", label: "Rejected" },
            { value: "approved", label: "Approved" },
            { value: "pendingApproval", label: "Pending Approval" }
          ]
        },
        {
          field: "createdOn",
          title: "Created On",
          options: [],
          isDate: true
        }
      ],
      tableRowActions: [
        { label: "Print", value: "print", faIcon: "print" },
        { label: "View", value: "view", faIcon: "eye" },
        {
          label: "Delete",
          value: "delete",
          faIcon: "trash-alt",
          class: "bg-red-400 text-white hover:text-white hover:bg-red-500"
        }
      ],
      agentId: ""
    };
  },
  methods: {
    async viewCallback(dataReceived: any): Promise<any> {
      const { _id } = dataReceived;
      this.$router.push(`/admin/agent_application/${_id}`);
    },
    ...agentApplicationsMapActions([
      "getAgentApplications",
      "deleteAgentApplications",
      "printAgentApplication"
    ]),
    async fetchPageData(queryObject: any) {
      try {
        this.loadingText = "Fetching agent applications. Please wait...";
        this.loading = true;
        this.$emit("scrollTop");
        await this.getAgentApplications({ query: { ...queryObject } });
      } catch (error) {
        this.$bugSnagClient.notify(error);
      } finally {
        this.loading = false;
        this.loadingText = "";
      }
    },
    // list view action
    async handleResponseAction(payload: any) {
      const { data } = payload;
      switch (payload.name) {
        case "print":
          await this.printCallback(data._id);
          break;
        case "delete":
          await this.deleteCallback(data._id);
          break;
        case "view":
          this.$router
            .push(`/admin/agent_application/${data._id}`)
            .catch(() => {});
          break;
        default:
          this.errorMessage = "Operation specified is not supported";
      }
    },
    async deleteCallback(agentID: string) {
      try {
        this.agentId = agentID;
        this.$modal.show("agentApplicationsModal");
      } catch (error) {
        this.errorMessage = error.message;
        this.$bugSnagClient.notify(error);
        // delete disabled
      }
    },
    async deleteOneAgentApplication() {
      try {
        this.loadingText = "Deleting agent application. Please wait...";
        await this.deleteAgentApplications(this.agentId);
        this.$modal.hide("agentApplicationsModal");
        this.$appNotifySuccess("Agent Application Deleted Successfully.");
      } catch (e) {
        this.errorMessage = e.message;
        this.$bugSnagClient.notify(e);
      } finally {
        this.loadingText = "";
      }
    },
    getAgentOperationsTable() {
      return AgentsTableOperationTableVue;
    }
  },
  computed: {
    ...agentApplicationsMapGetters([
      "agentApplications",
      "editingAgentApplication",
      "getTotalRecords",
      "getAgentApplicationLinks"
    ])
  }
});
